import React from 'react';
import './it.css';
import { FaLaptopCode, FaRobot, FaServer, FaCode, FaGraduationCap, FaCertificate, FaChalkboardTeacher, FaBriefcase } from 'react-icons/fa';
import { Link } from 'react-router-dom';


function ItCourses() {
  return (
    <div className="it-courses-page">
      {/* Hero Banner */}
      <section className="course-hero">
        <div className="hero-content">
          <h1>Information Technology Programs</h1>
          <p>Industry-recognized certifications and diplomas for tech careers</p>

        </div>
      </section>

      {/* Programs Overview */}
      <section className="programs-overview">
        <div className="container">
          <h2 className="section-title">Our IT Programs</h2>
          <div className="programs-grid">
            {/* Certificate in IT */}
            <div className="program-card">
              <div className="program-icon">
                <FaLaptopCode />
              </div>
              <h3>Certificate in Information Technology</h3>
              <div className="program-details">
                <p><strong>Duration:</strong> 6 Months</p>
                <p><strong>Format:</strong> Full-time/Part-time</p>
                <p><strong>Entry Requirements:</strong> O/Ls with English</p>
              </div>
              <div className="curriculum-highlights">
                <h4>Curriculum Highlights:</h4>
                <ul>
                  <li>Computer Fundamentals</li>
                  <li>Programming Basics</li>
                  <li>Network Essentials</li>
                  <li>Database Systems</li>
                </ul>
              </div>
              <button className="program-cta">View Details</button>
            </div>

            {/* Diploma in IT */}
            <div className="program-card featured">
              <div className="program-icon">
                <FaGraduationCap />
              </div>
              <h3>Diploma in Information Technology</h3>
              <div className="program-details">
                <p><strong>Duration:</strong> 1 Year</p>
                <p><strong>Format:</strong> Full-time</p>
                <p><strong>Entry Requirements:</strong> A/Ls or Cert. in IT</p>
              </div>
              <div className="curriculum-highlights">
                <h4>Curriculum Highlights:</h4>
                <ul>
                  <li>Advanced Programming</li>
                  <li>Web Development</li>
                  <li>System Administration</li>
                  <li>IT Project Management</li>
                </ul>
              </div>
              <button className="program-cta">View Details</button>
            </div>

            {/* Certificate in AI */}
            <div className="program-card">
              <div className="program-icon">
                <FaRobot />
              </div>
              <h3>Certificate in Artificial Intelligence</h3>
              <div className="program-details">
                <p><strong>Duration:</strong> 6 Months</p>
                <p><strong>Format:</strong> Part-time</p>
                <p><strong>Prerequisites:</strong> Basic Programming</p>
              </div>
              <div className="curriculum-highlights">
                <h4>Curriculum Highlights:</h4>
                <ul>
                  <li>Machine Learning</li>
                  <li>Neural Networks</li>
                  <li>Computer Vision</li>
                  <li>AI Ethics</li>
                </ul>
              </div>
              <button className="program-cta">View Details</button>
            </div>

            {/* Web Design & Development */}
            <div className="program-card">
              <div className="program-icon">
                <FaCode />
              </div>
              <h3>Web Design & Development</h3>
              <div className="program-details">
                <p><strong>Duration:</strong> 4 Months</p>
                <p><strong>Format:</strong> Full-time</p>
                <p><strong>Entry Requirements:</strong> Basic Computer Skills</p>
              </div>
              <div className="curriculum-highlights">
                <h4>Curriculum Highlights:</h4>
                <ul>
                  <li>HTML5/CSS3</li>
                  <li>JavaScript & Frameworks</li>
                  <li>UI/UX Design</li>
                  <li>Backend Development</li>
                </ul>
              </div>
              <button className="program-cta">View Details</button>
            </div>
          </div>
        </div>
      </section>

      {/* Program Comparison */}
      <section className="program-comparison">
        <div className="container">
          <h2 className="section-title">Program Comparison</h2>
          <div className="comparison-table">
            <table>
              <thead>
                <tr>
                  <th>Program</th>
                  <th>Duration</th>
                  <th>Credits</th>
                  <th>Career Outcomes</th>
                  <th>Certification</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Certificate in IT</td>
                  <td>6 Months</td>
                  <td>30 Credits</td>
                  <td>IT Support</td>
                  <td>APC Certificate</td>
                </tr>
                <tr>
                  <td>Diploma in IT</td>
                  <td>1 Year</td>
                  <td>60 Credits</td>
                  <td>IT Executive</td>
                  <td>APC Diploma Certificate</td>
                </tr>
                <tr>
                  <td>Certificate in AI</td>
                  <td>6 Months</td>
                  <td>30 Credits</td>
                  <td>AI Technician, ML Assistant</td>
                  <td>APC Certificate</td>
                </tr>
                <tr>
                  <td>Web Design & Development</td>
                  <td>4 Months</td>
                  <td>24 Credits</td>
                  <td>Web Developer, UI Designer</td>
                  <td>APC Certificate</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* Learning Features */}
      <section className="learning-features">
        <div className="container">
          <h2 className="section-title">Our Learning Experience</h2>
          <div className="features-grid">
            <div className="feature-card">
              <FaChalkboardTeacher className="feature-icon" />
              <h3>Expert Instructors</h3>
              <p>Industry professionals with 10+ years experience</p>
            </div>
            <div className="feature-card">
              <FaServer className="feature-icon" />
              <h3>Hands-on Labs</h3>
              <p>Real-world projects and cloud-based labs</p>
            </div>
            <div className="feature-card">
              <FaCertificate className="feature-icon" />
              <h3>Certification</h3>
              <p>Earn APC certifications</p>
            </div>
            <div className="feature-card">
              <FaBriefcase className="feature-icon" />
              <h3>Career Support</h3>
              <p>Job placement assistance and portfolio building</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="course-cta">
        <div className="container">
          <h2>Ready to Start Your IT Journey?</h2>
          <p>Applications for the next intake are now open</p>
          <div className="cta-buttons">
            <Link to="/apply" className="primary-cta">Apply Now</Link>

          </div>
        </div>
      </section>
    </div>
  );
}

export default ItCourses;